import React from 'react'
import { ThemeProvider } from 'styled-components'
import DefaultTheme from '../DefaultTheme'
import Helmet from 'react-helmet'
// Aquí tengo principalmente estilos de animación.
// Hay que mover esos estilos a styled components para pdoer dejar de cargar esta hoja de estilos
import '../index.css'

class DefaultLayout extends React.Component {
  render() {
    return (
      <ThemeProvider theme={DefaultTheme}>
        <div>
          <Helmet>
            <meta charSet="utf8" />
            <meta httpEquiv="Content-Type" content="text/html; charset=utf-8" />
          </Helmet>
          {this.props.children}
        </div>
      </ThemeProvider>
    )
  }
}

export default DefaultLayout
